/*
 * Persillo theme JS — loadet globalt fra layout/theme.liquid.
 * Alle handlers er guarded så de kun gør noget hvis det relevante DOM findes på siden.
 */

(function () {
  /* ---------------------------------------------------------------
     1) Klik-på-billede åbner zoom (kun mobil) — pointer-baseret tap detection
        Bobler ikke til carousel så swipe-conflict undgås.
     --------------------------------------------------------------- */
  // Module-state: holdes så vi kan sync'e main carousel med det slide brugeren
  // sluttede på inde i lightbox når den lukkes.
  let lightboxSourceCarousel = null;
  let lightboxLatestIndex = 0;

  function openLightboxFromMedia(mediaEl) {
    const carousel = mediaEl.closest('media-carousel');
    if (!carousel || !carousel.visibleItems) return;
    const visibleImages = carousel.visibleItems.filter(item => item.getAttribute('data-media-type') === 'image');
    const openIndex = visibleImages.indexOf(mediaEl);
    if (openIndex < 0) return;
    lightboxSourceCarousel = carousel;
    lightboxLatestIndex = openIndex;
    mediaEl.dispatchEvent(new CustomEvent('lightbox:open', {
      bubbles: true,
      detail: { index: openIndex }
    }));
  }

  function syncCarouselFromLightbox() {
    if (!lightboxSourceCarousel) return;
    const carousel = lightboxSourceCarousel;
    if (typeof carousel.select !== 'function') return;
    // Map lightbox-index (kun visible images) til carousel-item index
    const visibleImages = (carousel.visibleItems || []).filter(item => item.getAttribute('data-media-type') === 'image');
    const targetItem = visibleImages[lightboxLatestIndex];
    if (!targetItem) return;
    const carouselIndex = carousel.items ? carousel.items.indexOf(targetItem) : -1;
    if (carouselIndex < 0) return;
    try {
      carousel.select(carouselIndex, { animate: false });
    } catch (e) {
      // Carousel API kan have ændret sig — fail silently
    }
  }

  function attachTapHandlers(root) {
    const mediaItems = (root || document).querySelectorAll('.product-gallery__media[data-media-type="image"]');
    mediaItems.forEach(media => {
      if (media.dataset.persilloClickZoom === '1') return;
      media.dataset.persilloClickZoom = '1';

      let startX = 0, startY = 0, startT = 0, isPotentialTap = false;

      media.addEventListener('pointerdown', (e) => {
        if (window.matchMedia('(min-width: 1000px)').matches) return;
        startX = e.clientX; startY = e.clientY; startT = Date.now();
        isPotentialTap = true;
      }, { passive: true });

      media.addEventListener('pointermove', (e) => {
        if (!isPotentialTap) return;
        if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) {
          isPotentialTap = false;
        }
      }, { passive: true });

      media.addEventListener('pointerup', (e) => {
        if (!isPotentialTap) return;
        isPotentialTap = false;
        if (window.matchMedia('(min-width: 1000px)').matches) return;
        if (e.target.closest('button, a')) return;
        if (Date.now() - startT > 300) return;
        e.preventDefault(); e.stopPropagation();
        openLightboxFromMedia(media);
      });

      media.addEventListener('click', (e) => {
        if (window.matchMedia('(min-width: 1000px)').matches) return;
        if (e.target.closest('button, a')) return;
        e.stopPropagation();
      });
    });
  }

  /* ---------------------------------------------------------------
     2) Lightbox: progress-bar erstatter "1/9" counter; disable tap-zoom (pinch + swipe virker stadig)
     --------------------------------------------------------------- */
  function setupLightbox(pswp) {
    if (pswp.dataset.persilloLightboxReady === '1') return;
    pswp.dataset.persilloLightboxReady = '1';

    // Progress bar
    const bar = document.createElement('div');
    bar.className = 'persillo-lightbox-progress';
    const fill = document.createElement('div');
    fill.className = 'persillo-lightbox-progress__fill';
    bar.appendChild(fill);
    pswp.appendChild(bar);

    const updateBar = () => {
      const currentEl = pswp.querySelector('.pagination__current-page');
      const totalEl = pswp.querySelector('.pagination__page-count');
      if (!currentEl || !totalEl) return;
      const current = parseInt(currentEl.innerText, 10) || 1;
      const total = parseInt(totalEl.innerText, 10) || 1;
      fill.style.width = `${(current / total) * 100}%`;
    };
    updateBar();
    const currentEl = pswp.querySelector('.pagination__current-page');
    if (currentEl) {
      new MutationObserver(() => {
        updateBar();
        // Sync main carousel KONTINUERLIGT mens brugeren swiper i lightbox.
        // Når lightbox lukkes er carousellen allerede på rigtigt slide → ingen flash.
        const idx = parseInt(currentEl.innerText, 10);
        if (!isNaN(idx) && idx > 0) {
          lightboxLatestIndex = idx - 1;
          syncCarouselFromLightbox();
        }
      }).observe(currentEl, {
        childList: true, characterData: true, subtree: true
      });
    }

    // Disable tap-zoom inde i lightbox (pinch + swipe håndteres af PhotoSwipe via touch events og virker stadig)
    const slidesContainer = pswp.querySelector('.pswp__container') || pswp;
    let pdX = 0, pdY = 0, pdT = 0, pointerCount = 0;

    slidesContainer.addEventListener('pointerdown', (e) => {
      pointerCount++;
      pdX = e.clientX; pdY = e.clientY; pdT = Date.now();
    }, { capture: true });

    slidesContainer.addEventListener('pointerup', (e) => {
      pointerCount = Math.max(0, pointerCount - 1);
      if (pointerCount === 0) {
        const dx = Math.abs(e.clientX - pdX);
        const dy = Math.abs(e.clientY - pdY);
        const dt = Date.now() - pdT;
        // Kun stop hvis det er en tap (lille bevægelse, kort tid). Swipes har større dx — vi rører dem ikke.
        if (dx < 10 && dy < 10 && dt < 350) {
          e.stopPropagation();
          e.preventDefault();
        }
      }
    }, { capture: true });

    slidesContainer.addEventListener('dblclick', (e) => {
      e.stopPropagation();
      e.preventDefault();
    }, { capture: true });
  }

  document.addEventListener('lightbox:open', () => {
    let tries = 0;
    const tryAttach = () => {
      const pswp = document.querySelector('.pswp');
      if (pswp) {
        setupLightbox(pswp);
      } else if (tries++ < 30) {
        setTimeout(tryAttach, 50);
      }
    };
    tryAttach();
  });

  /* ---------------------------------------------------------------
     Loox-rating bracket-strip
     Loox's widget renderer producerer "[145] bedømmelser" pga.
     widget-mønstret i Loox admin. Vi piller de firkantede parenteser
     af så det bare bliver "145 bedømmelser" — matcher den editorial
     tone på resten af PDP'en.
     --------------------------------------------------------------- */
  function refineLooxRating(el) {
    if (el.dataset.persilloLooxRefined === '1') return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node, changed = false;
    while ((node = walker.nextNode())) {
      let v = node.nodeValue;
      if (/\[\d+\]/.test(v)) {
        v = v.replace(/\[(\d+)\]/g, '$1');
        changed = true;
      }
      if (/bedømmelser?/i.test(v)) {
        v = v.replace(/bedømmelser/gi, 'anmeldelser').replace(/bedømmelse/gi, 'anmeldelse');
        changed = true;
      }
      if (changed) node.nodeValue = v;
    }
    if (changed) el.dataset.persilloLooxRefined = '1';
  }

  function watchLoox() {
    document.querySelectorAll('.loox-rating, [data-testid="loox-rating-widget"]').forEach(el => {
      refineLooxRating(el);
      if (!el.dataset.persilloLooxObserved) {
        el.dataset.persilloLooxObserved = '1';
        new MutationObserver(() => refineLooxRating(el)).observe(el, { childList: true, subtree: true, characterData: true });
      }
    });
    shrinkLooxVideoStars();
  }

  /* ---------------------------------------------------------------
     Loox video-slider widgets bor i Shadow DOM, så vi kan ikke nå
     deres stjerne-SVG'er med normal CSS. Injicerer en lille style-block
     direkte ind i shadow root så stjernerne bliver mindre voldsomme.
     --------------------------------------------------------------- */
  function shrinkLooxVideoStars() {
    document.querySelectorAll('loox-video-slider-widget, loox-reviews').forEach(host => {
      if (host.dataset.persilloStarsScaled === '1') return;
      const root = host.shadowRoot;
      if (!root) return;
      const style = document.createElement('style');
      style.textContent = `
        /* Loox video-slider bruger <svg class="loox-icon"> inde i <span class="rating">.
           Reducer fra 20px til 12px (~60%) — mindre voldsomme på kort-niveau. */
        .rating .loox-icon,
        .rating svg,
        .lxs-icon svg,
        [class*="stars"] svg,
        [class*="rating-icons"] svg {
          width: 12px !important;
          height: 12px !important;
        }
        .rating {
          gap: 1px !important;
        }
        /* 4px rounded corners på video-slider cards — matcher resten af sitet
           (Loox admin tilbyder kun 0 eller 8, så vi tvinger 4 via CSS). */
        .swiper-slide,
        .swiper-slide-inner,
        .slide-stage,
        .photo-slide,
        .photo-slide img,
        .photo-slide video,
        video.video,
        img {
          border-radius: 4px !important;
        }
      `;
      /* Indsæt som FØRSTE child så vi vinder cascaden mod Loox' egen CSS */
      root.insertBefore(style, root.firstChild);
      host.dataset.persilloStarsScaled = '1';
    });
  }

  /* ---------------------------------------------------------------
     Init + reattach efter section reload (theme editor, variant skift)
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     PDP-galleri: hele billed-containeren bliver klikbar (åbner zoom-
     lightbox via den eksisterende <button is="product-zoom-button">
     der er skjult med display:none. Vi finder knappen og dispatcher
     click på den når brugeren klikker på billede-containeren.
     --------------------------------------------------------------- */
  function bindGalleryClickToZoom() {
    document.querySelectorAll('.product-gallery__media').forEach(media => {
      if (media.dataset.persilloZoomBound === '1') return;
      media.dataset.persilloZoomBound = '1';
      media.addEventListener('click', (e) => {
        // Ignore hvis brugeren klikker på en faktisk knap eller link inde i billedet
        if (e.target.closest('button, a')) return;
        const btn = media.querySelector('button[is="product-zoom-button"]');
        if (btn) btn.click();
      });
    });
  }

  /* ---------------------------------------------------------------
     Lightbox: klik på billedet lukker lightboxen (i stedet for at
     zoome yderligere ind via PhotoSwipe's default zoom-handler).
     --------------------------------------------------------------- */
  function bindLightboxClickToClose() {
    document.querySelectorAll('.pswp__img, .pswp__zoom-wrap').forEach(el => {
      if (el.dataset.persilloLightboxClose === '1') return;
      el.dataset.persilloLightboxClose = '1';
      el.addEventListener('click', (e) => {
        // Ignore clicks på faktiske knapper (close, pagination etc.)
        if (e.target.closest('button')) return;
        e.preventDefault();
        e.stopPropagation();
        const closeBtn = document.querySelector('.pswp__button--close');
        if (closeBtn) closeBtn.click();
      });
    });
  }

  /* ---------------------------------------------------------------
     Product-card badge-refinement: bold første tal i badge-tekster
     ("100 timers brændetid" → "<b>100</b> timers brændetid") så
     designet får visuelt anchor på USP-tallet.

     Note: ",00"-stripping er fjernet — håndteres nu af shop's
     Currency formatting i Shopify admin (Settings → General).
     --------------------------------------------------------------- */
  function boldBadgeNumbers(root) {
    const scope = root || document;
    const badges = scope.querySelectorAll('.product-card .badge');
    badges.forEach(b => {
      if (b.dataset.persilloBadgeBolded === '1') return;
      if (b.children.length > 0) return;
      // Trim hvidrum så Liquid-rendered tekst med indentation
      // ("\n      100 timers brændetid\n    ") ikke leverer ekstra mellemrum.
      const text = b.textContent.trim();
      const m = text.match(/^(\d+[\d.,]*)\s*(.*)$/s);
      if (!m) return;
      const num = m[1];
      const rest = m[2];
      const bold = document.createElement('b');
      bold.className = 'persillo-badge-num';
      bold.textContent = num;
      b.textContent = '';
      b.appendChild(bold);
      // Præcis ét space mellem tal og rest (ingen indentation-artefakter)
      if (rest) b.appendChild(document.createTextNode(' ' + rest));
      b.dataset.persilloBadgeBolded = '1';
    });
  }

  function refineProductCards(root) {
    boldBadgeNumbers(root);
  }

  /* ---------------------------------------------------------------
     Cart-drawer X-remove — bruger existing quantity-input AJAX flow
     i stedet for url_to_remove som navigerer til /cart side.
     --------------------------------------------------------------- */
  function bindCartRemoveButtons() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.line-item__remove');
      if (!btn) return;
      e.preventDefault();
      const lineItem = btn.closest('line-item');
      if (!lineItem) return;
      const input = lineItem.querySelector('input.quantity-input');
      if (!input) return;
      input.value = 0;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);
  }

  /* ---------------------------------------------------------------
     X) WISHLIST — H&M-style toggle med localStorage
        Storage: array af product handles. Cross-tab synk via 'storage' event.
        Custom event 'persillo:wishlist:change' broadcaster ændringer in-tab
        så heart-knapper + header-counter altid er i sync.
     --------------------------------------------------------------- */
  const WISHLIST_KEY = 'persillo_wishlist_v1';

  function readWishlist() {
    try {
      const raw = localStorage.getItem(WISHLIST_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(h => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('persillo:wishlist:change', { detail: { list } }));
  }
  function isInWishlist(handle) { return readWishlist().indexOf(handle) > -1; }
  function toggleWishlist(handle) {
    if (!handle) return;
    const list = readWishlist();
    const idx = list.indexOf(handle);
    if (idx > -1) list.splice(idx, 1); else list.push(handle);
    writeWishlist(list);
  }
  function removeFromWishlist(handle) {
    if (!handle) return;
    const list = readWishlist().filter(h => h !== handle);
    writeWishlist(list);
  }

  // Expose globally så wishlist-page section kan bruge det
  window.PersilloWishlist = {
    read: readWishlist,
    isIn: isInWishlist,
    toggle: toggleWishlist,
    remove: removeFromWishlist,
  };

  // Web component for heart-knappen
  if (!customElements.get('persillo-wishlist-button')) {
    class PersilloWishlistButton extends HTMLElement {
      connectedCallback() {
        this.syncState();
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onClick(e); }
        });
        this._changeHandler = () => this.syncState();
        document.addEventListener('persillo:wishlist:change', this._changeHandler);
      }
      disconnectedCallback() {
        document.removeEventListener('persillo:wishlist:change', this._changeHandler);
      }
      onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const handle = this.getAttribute('data-handle');
        toggleWishlist(handle);
      }
      syncState() {
        const handle = this.getAttribute('data-handle');
        const active = isInWishlist(handle);
        this.classList.toggle('is-active', active);
        this.setAttribute('aria-pressed', active ? 'true' : 'false');
        this.setAttribute('aria-label', active ? 'Fjern fra wish list' : 'Tilføj til wish list');
      }
    }
    customElements.define('persillo-wishlist-button', PersilloWishlistButton);
  }

  // Cross-tab sync via storage event
  window.addEventListener('storage', (e) => {
    if (e.key !== WISHLIST_KEY) return;
    document.dispatchEvent(new CustomEvent('persillo:wishlist:change', { detail: { list: readWishlist() } }));
  });

  // Header heart counter (badge med antal i wishlist)
  function syncHeaderWishlistCount() {
    const count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }
  document.addEventListener('persillo:wishlist:change', syncHeaderWishlistCount);

  /* ---------------------------------------------------------------
     X) QUICK-ADD LOADING SPINNER
     Tilføjer is-loading på "+"-knappen mens cart loader, fjerner igen
     når cart-drawer åbner eller efter en safety-timeout.
     --------------------------------------------------------------- */
  function bindQuickAddSpinner() {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.matches('form[is="product-form"], form[action*="/cart/add"]')) return;
      const btn = form.querySelector('.product-card__mobile-quick-buy-button, .persillo-hero-product__qb-mobile-btn');
      if (!btn) return;
      btn.classList.add('is-loading');
      // Safety: clear efter 2.5s hvis cart-drawer event aldrig fires
      setTimeout(() => btn.classList.remove('is-loading'), 2500);
    }, true);

    // Cart-drawer ændringer (open/refresh) → ryd alle loading-knapper
    function clearAll() {
      document.querySelectorAll('.is-loading.product-card__mobile-quick-buy-button, .is-loading.persillo-hero-product__qb-mobile-btn').forEach(b => b.classList.remove('is-loading'));
    }
    document.addEventListener('cart:refresh', clearAll);
    document.addEventListener('cart:change', clearAll);
    // Impact theme dispatcher cart-drawer events
    document.addEventListener('on:cart:after-add', clearAll);
    // Observe cart-drawer open via attribute
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      new MutationObserver(() => {
        if (drawer.hasAttribute('open')) clearAll();
      }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
  }

  /* ---------------------------------------------------------------
     PERSILLO BUNDLE SELECTOR — tier-klik præ-vælger quantity på det
     native produkt-form. ATC + rabat håndteres native/automatisk.
     --------------------------------------------------------------- */
  function bindBundleSelector() {
    document.querySelectorAll('persillo-bundle-selector').forEach(sel => {
      if (sel.dataset.pslBound === '1') return;
      sel.dataset.pslBound = '1';
      const qtyInput = sel.querySelector('[data-bundle-qty]');
      const tiers = sel.querySelectorAll('.psl-tier');
      const titlePrice = document.querySelector('[data-psl-title-price]');

      function syncTitlePrice(tier) {
        if (!titlePrice) return;
        const now = tier.dataset.now;
        const was = tier.dataset.was;
        const tNow = titlePrice.querySelector('[data-now]');
        const tWas = titlePrice.querySelector('[data-was]');
        if (tNow && now) tNow.textContent = now;
        if (tWas) {
          if (was) { tWas.textContent = was; tWas.hidden = false; }
          else { tWas.hidden = true; }
        }
      }

      tiers.forEach(tier => {
        tier.addEventListener('click', () => {
          tiers.forEach(t => { t.classList.remove('is-selected'); t.setAttribute('aria-pressed', 'false'); });
          tier.classList.add('is-selected');
          tier.setAttribute('aria-pressed', 'true');
          if (qtyInput) qtyInput.value = tier.dataset.packs;
          syncTitlePrice(tier);
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     BLAND SELV MODAL — link under beskrivelse åbner popup.
     --------------------------------------------------------------- */
  function bindBlandSelvModal() {
    const modal = document.querySelector('[data-psl-blandselv-modal]');
    if (!modal || modal.dataset.pslBound === '1') return;
    modal.dataset.pslBound = '1';
    const openBtn = document.querySelector('[data-psl-blandselv-open]');
    const closeEls = modal.querySelectorAll('[data-psl-blandselv-close]');
    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }
    if (openBtn) openBtn.addEventListener('click', open);
    closeEls.forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  /* ---------------------------------------------------------------
     REVIEWS SLIDER — pile scroller track ét slide; swipe er native (scroll-snap).
     --------------------------------------------------------------- */
  function bindReviewsSlider() {
    document.querySelectorAll('.psl-reviews').forEach(slider => {
      if (slider.dataset.pslBound === '1') return;
      slider.dataset.pslBound = '1';
      const track = slider.querySelector('[data-psl-reviews-track]');
      if (!track) return;
      const step = () => track.querySelector('.psl-reviews__slide')?.offsetWidth || track.clientWidth;
      // Pile sidder per slide nu, så bind dem alle.
      slider.querySelectorAll('[data-psl-reviews-prev]').forEach(b => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
      slider.querySelectorAll('[data-psl-reviews-next]').forEach(b => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
    });
  }

  /* ---------------------------------------------------------------
     GALLERY DEEP-LINK — #m{media_id} i URL'en (fra hero-produkt på forsiden)
     navigerer PDP-galleriet til præcis det billede man klikkede på.
     --------------------------------------------------------------- */
  function bindGalleryDeepLink() {
    const hash = window.location.hash;
    if (!hash || hash.indexOf('#m') !== 0) return;
    const mediaId = hash.slice(2);
    if (!/^\d+$/.test(mediaId)) return;
    const gallery = document.querySelector('media-carousel.product-gallery__media-list');
    if (!gallery) return;
    const items = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__media'));
    const target = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    if (!target) return;
    const idx = items.indexOf(target);
    if (idx < 0) return;
    let done = false;
    const go = () => {
      if (done) return;
      if (typeof gallery.select === 'function') {
        try { gallery.select(idx, { animate: false }); done = true; return; } catch (e) {}
      }
      try { target.scrollIntoView({ inline: 'center', block: 'nearest' }); done = true; } catch (e) {}
    };
    go();
    // Carousel kan initialisere sent — prøv igen et par gange
    setTimeout(go, 250);
    setTimeout(go, 700);
  }

  function init() {
    attachTapHandlers();
    bindBlandSelvModal();
    bindReviewsSlider();
    bindGalleryDeepLink();
    bindGalleryClickToZoom();
    bindCartRemoveButtons();
    refineProductCards();
    syncHeaderWishlistCount();
    bindQuickAddSpinner();
    bindBundleSelector();
    new MutationObserver(() => {
      bindGalleryClickToZoom();
      bindLightboxClickToClose();
      refineProductCards();
      bindBundleSelector();
      bindBlandSelvModal();
      bindReviewsSlider();
    }).observe(document.body, { childList: true, subtree: true });
    watchLoox();
    // Body-observer fanger Loox-widgets der renderes async efter init
    new MutationObserver(() => watchLoox()).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', e => {
    attachTapHandlers(e.target);
    watchLoox();
  });
})();
